import { initializeFaro, getWebInstrumentations } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export const initFaro = () => {
    initializeFaro({
        url: process.env.REACT_APP_GRAFANA_URL,
        app: {
            name: 'tpvhorizon',
            version: '1.0.0',
            environment: process.env.REACT_APP_ENV
        },
        instrumentations: [
            ...getWebInstrumentations(),
            new TracingInstrumentation(),
        ],
    });
};
